<template>
  <fragment>
    <span class="message" v-if="!stopMessage" id="startingMessage"></span>
    <span class="message" v-else>{{ message }}</span>
  </fragment>
</template>

<script>
import Typed from 'typed.js';

export default {
  name: 'welcomeMessage',
  props: ['message', 'onComplete', 'stopMessage'],
  data() {
    return {
      typed: undefined
    };
  },
  watch: {
    stopMessage: function() {
      if (!this.typed) return;
      this.typed.destroy();
      this.onComplete();
    }
  },
  mounted() {
    this.typed = new Typed('#startingMessage', {
      strings: [this.message],
      typeSpeed: 10,
      showCursor: false,
      onComplete: () => this.onComplete()
    });
  }
};
</script>

<style scoped>
.message {
  line-height: 1rem;
  max-width: 80%;
}
</style>
